import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/xbox': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M369.9 318.2C414.2 372.5 434.6 417 424.3 436.9 416.4 452 367.6 481.5 331.7 492.8 302.1 502.1 263.3 506.1 231.3 503 193.1 499.3 154.4 485.6 121.2 464 93.3 445.8 87 438.3 87 423.4 87 393.5 119.9 341.1 176.2 281.3 208.2 247.4 252.7 207.6 257.6 208.7 267 210.8 341.9 283.8 369.9 318.2zM188.6 143.8C158.9 116.9 130.5 89.9 102.2 80.4 87 75.3 85.9 75.6 73.5 88.5 44.3 118.9 20 168.2 13.2 210.9 7.8 245.1 7.1 254.7 9 271.4 14.6 321.9 26.3 356.8 49.5 392.3 59 406.9 61.6 409.6 58.8 402.2 54.6 391.2 58.5 364.7 68.3 338.2 82.6 299.2 122.2 225.3 188.6 143.8zM500.2 207.3C483.3 127.3 432.7 77 425.6 77 418.3 77 401.4 83.5 389.6 90.9 366.3 105.4 348.6 122.3 325.3 143.7 367.7 197 427.5 283.1 448.2 346 455 366.7 457.9 387.1 455.6 398.3 453.9 406.8 453.9 406.8 457 402.9 463.1 395.2 476.9 371.6 482.4 359.4 489.8 343.2 497.4 319.2 501 300.7 505.3 278.2 504.9 229.9 500.2 207.3zM141.3 43C189 40.5 251 77.5 255.6 78.4 256.3 78.5 266 74.2 277.2 68.7 341.1 37.6 371.2 42.9 384.6 43.5 320.7 4.2 231.9-6.5 150.7 31.8 127.3 42.9 126.7 43.7 141.3 43z'
      }
    ]
  }
})
